module.exports = __webpack_public_path__ + "static/media/ubrand_paperclip.17d2a3cc.png";